'use client';

import { useEffect } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Grid2 as Grid } from '@mui/material';
import { PrimaryButton } from '@/lib/components/Common/Buttons';
import { PrimaryTextLink } from '@/lib/components/Common/Links';
import { reportRenderError } from '@/lib/server-actions/report-render-error';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log only client-side errors here (no digest).
    // Server-rendered errors include a digest and are reported via instrumentation onRequestError.
    // This avoids duplicate reports and keeps SSR errors handled on the server.
    if (!error.digest) {
      void reportRenderError({
        url: window.location.href,
        message: error?.message,
        stack: error?.stack,
        digest: error?.digest,
        handledBy: 'global-error',
      });
    }
  }, [error]);

  return (
    <>
      <CssBaseline />
      <Grid container>
        <Grid size={6} component="div" direction="column" sx={{ p: '1rem 3rem' }}>
          <h2>Sivulla tapahtui virhe!</h2>
          <p>Jos ongelma jatkuu, ota yhteyttä asiakaspalveluumme ja kerro ongelmasta.</p>
          {error.digest && (
            <p>
              <strong>Error id:</strong> {error.digest}
            </p>
          )}

          {process.env.NODE_ENV === 'development' && (
            <p>
              <strong>Error message:</strong> {error.message ?? 'no message'}
            </p>
          )}
          <Grid container>
            <Grid component="div" direction="column">
              <PrimaryButton
                style={{ display: 'inline-block' }}
                variant="contained"
                color="primary"
                onClick={() => reset()}
              >
                Yritä uudelleen
              </PrimaryButton>
            </Grid>
            <Grid component="div" direction="column">
              <PrimaryTextLink href="/">Takaisin etusivulle</PrimaryTextLink>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
